/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerPreviewArticleResponse } from './BlogManagerPreviewArticleResponse';

export type BlogManagerPreviewArticleResponseApiRespoonse = {
    data?: BlogManagerPreviewArticleResponse;
    status?: BlogManagerPreviewArticleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BlogManagerPreviewArticleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

